import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", as: Tag = "h1" }) {
  const MotionTag = motion.create(Tag);
  return (
    <MotionTag className={className} initial="hidden" animate="show">
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`block ${lineClassName}`}
            variants={{
              hidden: { y: "110%", rotate: 2 },
              show: {
                y: "0%",
                rotate: 0,
                transition: { duration: 0.9, delay: 0.15 + i * 0.13, ease: [0.22, 1, 0.36, 1] },
              },
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}

export function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden border-y border-ink/10 bg-forest py-4 ${className}`} data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display text-lg italic text-paper/90">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-lime" />
          </span>
        ))}
      </div>
    </div>
  );
}

export function SectionTag({ children, dark = false }) {
  return (
    <p
      className={`mb-4 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] ${
        dark ? "text-lime" : "text-moss"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-lime" : "bg-forest"}`} />
      {children}
    </p>
  );
}
